export const getRandomArrayIndex = (array) => {
    if (!Array.isArray(array) || !array.length) return null;
    return Math.floor(Math.random() * array.length);
};
